import React from "react";
import { Typography } from "@material-ui/core";

export const mentorshipAvailabilitySchema = {
  title: "Request Mentorship from SAICE Connect Community",
  logicalname: "Contact",
  type: "object",
  description:
    "Do you need guidance and mentorship to reach your full potential? Find a member who is open to mentorship.",
  additionalDescription: () => (
    <>
      <Typography component="span" style={{ fontWeight: 700 }}>Important</Typography>: To be matched with mentors, you must complete both the <Typography component="span" style={{ fontWeight: 700 }}>Topics</Typography> tab and your <Typography component="span" style={{ fontWeight: 700 }}>Availability</Typography> below. Profiles with incomplete information will not be considered for matching.
    </>
  ),
  required: [
    "ctpt_optedintosaiceconnect",
    "ctpt_availabledaytime",
    "ctpt_availableevenings",
    "ctpt_availableonweekdays",
    "ctpt_availableonweekends",
  ],
  properties: {
    ctpt_optedintosaiceconnect: {
      title: "Do You Wish to Opt-in to recieve mentorship from SAICE Connect Community?",
      type: "string",
      schemaname: "ctpt_optedintosaiceconnect",
      datatype: "string",
      requiredCheck: true,
      // NOTE: These enum values are placeholders. You need to check your CRM 
      // to get the actual option set values for this Choice field.
      // In Dataverse/Power Platform, Choice fields typically use numeric values like "533910000", "533910001"
      // You can find these values in the CRM by checking the field's option set values
      enum: ["533910000", "533910001"], // TODO: Replace with actual CRM option set values
      enumNames: ["Yes", "No"],
      // Validation: Required field - enum constraint ensures only valid values are selected
    },
    ctpt_connectmentee: {
      title: "Are you available for mentoring from mentors matched to your interests?",
      type: "string",
      schemaname: "ctpt_connectmentee",
      datatype: "string",
      requiredCheck: false,
      enum: ["True", "False"],
      enumNames: ["Yes", "No"]
    },
    ctpt_availabledaytime: {
      title: "Available Daytime",
      type: "string",
      schemaname: "ctpt_availabledaytime",
      datatype: "string",
      requiredCheck: true,
      enum: ["True", "False"],
      enumNames: ["Yes", "No"],
      // Validation: Required field - enum constraint ensures only True/False values are selected
    },
    ctpt_availableevenings: {
      title: "Available Evenings",
      type: "string",
      schemaname: "ctpt_availableevenings",
      datatype: "string",
      requiredCheck: true,
      enum: ["True", "False"],
      enumNames: ["Yes", "No"],
      // Validation: Required field - enum constraint ensures only True/False values are selected
    },
    ctpt_availableonweekdays: {
      title: "Available On Weekdays",
      type: "string",
      schemaname: "ctpt_availableonweekdays",
      datatype: "string",
      requiredCheck: true,
      enum: ["True", "False"],
      enumNames: ["Yes", "No"],
      // Validation: Required field - enum constraint ensures only True/False values are selected
    },
    ctpt_availableonweekends: {
      title: "Available On Weekends",
      type: "string",
      schemaname: "ctpt_availableonweekends",
      datatype: "string",
      requiredCheck: true,
      enum: ["True", "False"],
      enumNames: ["Yes", "No"],
      // Validation: Required field - enum constraint ensures only True/False values are selected
    },
    ctpt_availabilitynotes: {
      title: "Availability Notes",
      type: "string",
      schemaname: "ctpt_availabilitynotes",
      datatype: "string",
      requiredCheck: false,
      // Pattern validation: allows empty string OR string that doesn't start with space
      // This prevents the validation error from showing on initial load when field is empty
      pattern: '^$|^[^ ].*$',
      message: "Text cannot start with a space. Please remove leading spaces.",
      minLength: 0,
      maxLength: 1000,
      // Validation rules:
      // - Optional field (can be empty)
      // - If provided, cannot start with a space
      // - Maximum 1000 characters allowed
    },
  },
};

